<template>
  <div class="pc" v-if="!isMobile">
    <div class="home">
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        :ellipsis="false"
        active-text-color="#ffd04b"
        @select="handleSelect"
      >
        <el-menu-item index="0" v-if="language">
          <img
            src="../assets/logo_name.png"
            alt="Element logo"
          />
        </el-menu-item>
        <el-menu-item index="0" v-if="!language">
          <img
            src="../assets/logo_name_us.png"
            alt="Element logo"
          />
        </el-menu-item>
        <el-menu-item index="1" v-if="language" style="margin-right: 100px;font-size: 20px;" @click="changeLanguage('en')">EN</el-menu-item>
        <el-menu-item index="1" v-if="!language" style="margin-right: 100px;font-size: 20px;" @click="changeLanguage('zh-cn')">ZH</el-menu-item>
      </el-menu>
      <div class="home-content">
        
          <div style="margin-top: 176px;text-align: left;margin-left: 260px;">
            <div style="display: flex;align-items: center;">
              <span style="font-size: 48px;color: #000000;font-weight: bold;">{{ $t('title') }}</span>
              <span style="border: 1px solid #FFCC20;border-radius: 5px;color: #FFCC20;font-size: 18px; margin-left: 15px;font-weight: bold;">{{$t('smallTitle')}}</span>
            </div>
            <div style="font-size: 48px;color: #000000;font-weight: bold;width: 500px;">{{$t('describe')}}</div>
            <p style="color: #505050 ;font-size: 20px;margin-top: 15px;">{{$t('content')}}</p>
            <div style="display: flex;margin-top: 40px;">
              <div style="background-color: #FFE600 ;width: 190px;height: 50px;border: 1px solid;border-radius: 25px;  display: flex;justify-content: center;align-items: center;">
                <img src="../assets/ios.png">
                <el-popover
                  class="box-item"
                  title=""
                  placement="bottom"
                  width="160px"
                >
                <img style="width: 132px;" src="../assets/iphone_download.png">
                  <template #reference><span style="margin-left: 10px;">{{$t('iosDownload')}}</span></template>
              </el-popover>
              </div>
              <div style="background-color: #FFE600 ;width: 190px;height: 50px;border: 1px solid;border-radius: 25px; display: flex;justify-content: center;align-items: center;margin-left: 20px;">
                <img src="../assets/android.png">
                <el-popover
                  class="box-item"
                  title=""
                  placement="bottom"
                  width="160px"
                >
                <img style="width: 132px;" src="../assets/android_download.png">
                <template #reference><span style="margin-left: 10px;">{{$t('AndroidDownload')}}</span></template>
                </el-popover>
              </div>
            </div>
      
        </div>
        <div class="home-content-right">
          <img v-if="language" src="../assets/home_right.png">
          <img v-if="!language" src="../assets/home_right_us.png">
        </div>
      </div>
    </div>
    <div class="content_one">
    <el-row>
      <el-col :span="8">
        <div class="" style="margin-top: 246px;text-align: left;margin-left: 291px;">
          <span class="content-one-title" style="font-size: 48px;font-weight: bold;">
            {{$t('twoTitle')}}
          </span>
          <p style="color: #505050;font-size: 20px;"> {{$t('twoDescribe')}} | {{$t('twoDescribeTwo')}}</p>
          <p style="color: #505050;font-size: 20px;">{{$t('twoDescribeThree')}} | {{$t('twoDescribeFour')}}</p>
          <hr style="width: 100px; margin-top: 50px;border-top: 6px solid #FFCC20;margin-left: 0px;">
        </div>
        
      </el-col>
      <el-col :span="16">
        <div style="margin-top: 160px;text-align: left;margin-left: 110px; width: 872px;display: flex;flex-wrap: wrap;">
          <div v-for="(item, index) in imgList" :key="index" style="width: 130px;margin-left: 88px;">
            <img :src="item.url" >
            <p v-if="language" style="text-align: center;height: 60px;">{{item.name}}</p>
            <p v-if="!language" style="text-align: center;">{{item.nameUs}}</p>
          </div>
        </div>
      </el-col>
    </el-row>
    </div>
    <div class="content_two">
    <div class="content_two_title">{{$t('threeTitle')}}</div>
    <div style="margin-top: 15px;color: #808080 ; font-size: 24px;">{{$t('threeDescribe')}}</div>
    <div class="parent" >
      <div class="show" v-for="(item,index) in dataList" :key="index">
          {{ item }}
      </div>
    </div>
    <div class="parent-two">
      <div class="show" v-for="(item,index) in dataListTwo" :key="index">
          {{ item }}
      </div>
    </div>
    <div class="parent" >
      <div class="show" v-for="(item,index) in dataList" :key="index">
          {{ item }}
      </div>
    </div>
    </div>
    <div class="content_three">
    <div  class="content_three_title">{{ $t('fourTitle') }}</div>
    <div style="margin-top: 15px;color: #808080 ; font-size: 24px;">{{ $t('fourDescribe') }}</div>
    <div style="margin-top: 100px;display: flex;align-items: center;">
        <!-- 左侧图标 -->
        <el-divider content-position="center">
        <img class="el-icon-position left-icon" src="../assets/down_logo.png"></img>
      </el-divider>
      
      <!-- 中间图标 -->
      <el-divider content-position="center">
        <img class="el-icon-star-on center-icon" src="../assets/binding.png"></img>
      </el-divider>
      
      <!-- 右侧图标 -->
      <el-divider content-position="center">
        <img class="el-icon-position right-icon" src="../assets/rider.png"></img>
      </el-divider>
    </div>
    <div style="display: flex;margin-top: 20px;">
      <div style="flex: 1;justify-content: center;margin: 0 auto;">
        <span style="font-size: 45px;color: #1A1A1A ;">01</span>
        <span style="font-size: 24px;color: #1A1A1A;margin-left: 5px;">{{ $t('fourContentFirstTitle') }}</span>
        <p style="font-size: 18px;color: #808080;">{{$t('fourContentFirstContent')}}<br>{{$t('fourContentFirstContentTwo')}}</p>
      </div>
      <div style="flex: 1;">
        <span style="font-size: 45px;color: #1A1A1A ;">02</span>
        <span style="font-size: 24px;color: #1A1A1A;margin-left: 5px;">{{ $t('fourContentSecondTitle') }}</span>
        <p style="font-size: 18px;color: #808080;">{{ $t('fourContentSecondContent') }}<br>{{ $t('fourContentSecondContentTwo') }} <br>{{ $t('fourContentSecondContentThree') }}</p>
      </div>
      <div style="flex: 1;">
        <span style="font-size: 45px;color: #1A1A1A ;">03</span>
        <span style="font-size: 24px;color: #1A1A1A;margin-left: 5px;">{{ $t('fourContentThirdTitle') }}</span>
        <p style="font-size: 18px;color: #808080;">{{ $t('fourContentThirdContent') }}<br>{{ $t('fourContentThirdContentTwo') }}<br>{{ $t('fourContentThirdContentThree') }}</p>
      </div>
    </div>
    </div>
    <div class="foot">
    <img v-if="language" src="../assets/logo_name.png">
    <img v-if="!language" src="../assets/logo_name_us.png">
    <p style="font-size: 16px;color: #FFFFFF;">{{ $t('footTitle') }}</p>
    <el-divider border-style="double" />
    <div style="margin-top: 30px;">
      <span style="font-size: 16px;color: #FFFFFF;float: left;opacity: 0.5;">{{ $t('footCompanyName') }}</span>
      <!-- <span style="float: right;"><a href="https://beian.miit.gov.cn/" style="color: #FFFFFF;font-size: 16px;opacity: 0.5;">{{ $t('footRecordNumber') }}</a></span> -->
    </div>
    </div>
</div>
<div class="phone" v-if="isMobile">
  <div class="phone-home">
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        :ellipsis="false"
        active-text-color="#ffd04b"
        @select="handleSelect"
      >
        <el-menu-item index="0" v-if="language">
          <img
            src="../assets/logo_name.png"
            alt="Element logo"
          />
        </el-menu-item>
        <el-menu-item index="0" v-if="!language">
          <img
            src="../assets/logo_name_us.png"
            alt="Element logo"
          />
        </el-menu-item>
        <el-menu-item index="1" v-if="language" style="font-size: 20px; margin-right: 0 auto;" @click="changeLanguage('en')">EN</el-menu-item>
        <el-menu-item index="1" v-if="!language" style="font-size: 20px;" @click="changeLanguage('zh-cn')">ZH</el-menu-item>
      </el-menu>
      <div class="home-content">
        <div style="display: flex;align-items: center;margin-top: 40px;">
          <span style="font-size: 34px;color: #000000;font-weight: bold;margin-left: 30px;">{{ $t('title') }}</span>
        </div>
        <div style="font-size: 34px;color: #000000;font-weight: bold;text-align: left;margin-left: 30px;">{{$t('describe')}}</div>
        <p style="color: #505050 ;font-size: 12px;margin-top: 10px;text-align: left;margin-left: 30px;">{{$t('content')}}</p>
      
        <div class="home-content-right">
          <img v-if="language" src="../assets/home_right.png">
          <img v-if="!language" src="../assets/home_right_us.png">
        </div>
        <div style="margin-top: 40px;">
              <div style="margin: 0 auto;background-color: #FFE600 ;width: 305px;height: 50px;border: 1px solid;border-radius: 25px;  display: flex;justify-content: center;align-items: center;" @click="toAppStore">
                <img src="../assets/ios.png">
                <span style="margin-left: 10px;font-size: 15px;">{{$t('iosDownload')}}</span>
               
              </div>
              <div style="margin: 0 auto; margin-top: 20px;background-color: #FFE600 ;width: 305px;height: 50px;border: 1px solid;border-radius: 25px; display: flex;justify-content: center;align-items: center;" @click="toGooglePlay">
                <img src="../assets/android.png">
                <span style="margin-left: 10px;font-size: 15px;">{{$t('AndroidDownload')}}</span>
              </div>
            </div>
      </div>
    </div>
    <div class="content_one">
        <span class="content-one-title" style="font-size: 24px;font-weight: bold;">
          {{$t('twoTitle')}}
        </span>
        <p style="color: #505050;font-size: 10px;"> {{$t('twoDescribe')}} | {{$t('twoDescribeTwo')}} | {{$t('twoDescribeThree')}} | {{$t('twoDescribeFour')}}</p>
        
        <hr style="width: 50px; margin-top: 22px;border-top: 3px solid #FFCC20;">
      
      <div style="display: flex;flex-wrap: wrap; margin-top: 34px;justify-content: center;margin-left: -38px;">
        <div v-for="(item, index) in imgList" :key="index" style="width: 50px;margin-left: 38px;">
          <img :src="item.url" style="width: 50px;">
          <p v-if="language" style="text-align: center;height: 60px;font-size: 10px;">{{item.name}}</p>
          <p v-if="!language" style="text-align: center;font-size: 10px;">{{item.nameUs}}</p>
        </div>
      </div>
    </div>
    <div class="content_two">
      <p class="content_two_title">{{$t('threeTitle')}}</p>
      <p style="color: #505050;font-size: 10px;"> {{$t('twoDescribe')}} | {{$t('twoDescribeTwo')}} | {{$t('twoDescribeThree')}} | {{$t('twoDescribeFour')}}</p>
      <div class="parent" >
        <div class="show" v-for="(item,index) in dataList.slice(0,3)" :key="index">
            {{ item }}
        </div>
      </div>
      <div class="parent-two">
        <div class="show" v-for="(item,index) in dataList.slice(3,6)" :key="index">
            {{ item }}
        </div>
      </div>
      <div class="parent" >
        <div class="show" v-for="(item,index) in dataList.slice(5,8)" :key="index">
            {{ item }}
        </div>
      </div>
    </div>
    <div class="content_three">
      <p  class="content_three_title">{{ $t('fourTitle') }}</p>
      <div style="color: #808080 ; font-size: 12px;">{{ $t('fourDescribe') }}</div>
      <hr style="width: 50px; margin-top: 22px;border-top: 3px solid #FFCC20;">
      <div style="height: 300px; display: flex;justify-content: center;margin-left: 30px; margin-top: 32px;">
      <el-steps direction="vertical" >
        <el-step :title="'01 '+ $t('fourContentFirstTitle')" :description="$t('fourContentFirstContent')+''+$t('fourContentFirstContentTwo')">
          <template #icon>
            <img style="width: 35px;" class="el-icon-position left-icon" src="../assets/down_logo.png"></img>
          </template>
        </el-step>
        <el-step :title="'02 ' + $t('fourContentSecondTitle')" :description="$t('fourContentSecondContent')+ ''+ $t('fourContentSecondContentTwo')+'' + $t('fourContentSecondContentThree')" >
          <template #icon>
            <img style="width: 16px;" class="el-icon-star-on center-icon" src="../assets/binding.png"></img>
          </template>
        </el-step>
        <el-step :title="'03 '+ $t('fourContentThirdTitle')"  :description="$t('fourContentThirdContent') +''+ $t('fourContentThirdContentTwo') +''+ $t('fourContentThirdContentThree') " >
          <template #icon>
            <img style="width: 35px;" class="el-icon-position right-icon" src="../assets/rider.png"></img>
          </template>
        </el-step>
      </el-steps>
  </div>
  </div>
  <div class="foot">
    <img v-if="language" src="../assets/logo_name.png" style="height: 20px;">
    <img v-if="!language" src="../assets/logo_name_us.png"style="height: 20px;">
    <span style="font-size: 12px;color: #FFFFFF;float: right;">{{ $t('footTitle') }}</span>
    <el-divider border-style="double" />
    <div style="margin-top: 20px;">
      <p style="font-size: 10px;color: #FFFFFF;opacity: 0.5;">{{ $t('footCompanyName') }}</p>
      <!-- <a href="https://beian.miit.gov.cn/" style="color: #FFFFFF;font-size: 10px;opacity: 0.5;">{{ $t('footRecordNumber') }}</a> -->
    </div>
  </div>
</div>
</template>
<script setup>
// @ is an alias to /src
import { reactive,onMounted , ref} from 'vue';
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n({
  useScope: 'global', // 使用全局作用域
})
const language = ref(false)
const data = reactive(["社交互动，骑乐无穷","骑行记录，见证成长","开启自由骑行之旅","智能解锁秒速出发","智能路线规划","健康数据追踪","酷骑你的骑行搭档","Z时代最喜欢的产品之一"])
const dataUs = reactive(["Social interaction, endless riding fun", "Riding records, witnessing growth", "Embark on a journey of free riding", "Smart unlocking for instant departure", "Smart route planning", "Health data tracking", "Cool Ride, your cycling companion", "One of the favorite products of Generation Z"])
let dataList = reactive([])
let dataListTwo = reactive([])
onMounted(() => {
  const a = locale.value;
  if(a == 'zh-cn'){
    language.value = true
    Object.assign(dataList, data)
    dataListTwo = data.slice().reverse()
  }else{
    language.value = false
    Object.assign(dataList, dataUs)
    dataListTwo = dataUs.slice().reverse()
  }
  checkDeviceType()
})
const isMobile = ref(false)
const checkDeviceType = () => {
  const userAgent = navigator.userAgent.toLowerCase()
  // 常见移动设备的 User-Agent 关键词
   isMobile.value = /mobile|android|iphone|ipad|phone/i.test(userAgent)

   const isiOS = /iphone|ipad|ipod|ios/.test(userAgent) || 
   /\(i[^;]+;( u;)? cpu.+mac os x/.test(userAgent);
   const isAndroid = /android|linux; android/.test(userAgent);
   debugger
   if(isiOS){
			location.href = 'https://www.jlinksz.com/app';
		}else if(isAndroid){
			location.href = 'jlink://com.jl.ride/home';
		}
}

const toAppStore = () => {
  window.open('https://apps.apple.com/us/app/hiriders/id6670234602')
}
const toGooglePlay = () => {
  window.open('https://play.google.com/store/apps/details?id=com.jlink.jlridecar')
}

const imgList = reactive([
{url:require('@/assets/one.png'),name:'智能解锁',nameUs:'Smart Unlock'},
{url:require('@/assets/two.png'),name:'智能路线规划',nameUs:'Intelligent route planning'},
{url:require('@/assets/three.png'),name:'骑行成就系统',nameUs:'Cycling Achievement System'},
{url:require('@/assets/four.png'),name:'健康数据追踪',nameUs:'Health data tracking'},
{url:require('@/assets/five.png'),name:'社交互动',nameUs:'Social interaction'},
{url:require('@/assets/six.png'),name:'骑行信息记录',nameUs:'Cycling information record'},
{url:require('@/assets/seven.png'),name:'车辆信息',nameUs:'Vehicle information'},
{url:require('@/assets/eight.png'),name:'精准定位',nameUs:'Precise Positioning'},
]
)
// 定义切换语言的方法
const changeLanguage = (lang) => {
  if(lang == 'zh-cn'){
    language.value = true
    Object.assign(dataList, data)
    dataListTwo = data.slice().reverse()
  }else{
    language.value = false
    Object.assign(dataList, dataUs)
    dataListTwo = dataUs.slice().reverse()
  }
  locale.value = lang // 直接修改 locale 值
  localStorage.setItem('locale', lang) // 可选：保存语言偏好到本地存储
}
</script>
<style>
.pc .el-menu{
  height: 80px;
}
.pc .el-menu--horizontal > .el-menu-item:nth-child(1) {
  margin-right: auto;
}
.pc .el-menu-item  > img {
  height: 36px;
  margin-top: 22px;
  margin-bottom: 22px;
  margin-left: 220px;
}

.pc .el-menu-item {
  font-size: 20px;
}
.pc .home{
  height: 800px;
  background-image: url('../assets/home_bg.png');
}
.pc .home-content{
  display: flex;
}
.pc .home-content-left{
  flex: 1;
}
.pc .home-content-right {
  flex: 1;
 
}
.pc .home-content-right > img{
  margin-top: 69px;
  width: 438px;
}
.pc .content_one{
  height: 790px;
  background-image: url('../assets/content_one_bg.png');
}
.pc .content-one-title{
  font-size: 48px;
  font-weight: bold;
  background-image: url('../assets/conten_one_title_bg.png');
  background-size: auto;
  background-position: right; /* 居中显示 */
  background-repeat: no-repeat; /* 禁止重复 */
}
.pc .content_two{
  min-height: 506px;
  background-color: #FFF9E5 ;
  padding-top: 90px;
  overflow: hidden;
  padding-bottom: 60px;
}
.pc .content_two_title{
  font-size: 48px;
  font-weight: bold;
}
.pc .content_three{
  padding-bottom: 80px;
  padding-top: 80px;
}
.pc .content_three_title{
  font-size: 48px;
  font-weight: bold;
}
.pc .foot{
  background-color: #1A1A1A;
  height: 254px;
  text-align: left;
  padding-top: 40px;
  padding-left: 207px;
  padding-right: 207px;
}
.pc .parent{
  display: flex;
  margin-top: 60px;
  overflow: hidden;
  animation: scroll  20s linear infinite;
}
.pc .parent-two{
  display: flex;
  margin-top: 60px;
  overflow: hidden;
  animation: scrolltwo  20s linear infinite;
}
.pc .show{
  border: 3px solid transparent;
  border-radius: 10px;
  min-width: 150px;
  font-size: 20px;
  min-height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 20px 20px 10px 20px;
  margin-left: 50px;
  padding: 5px;
  box-sizing: border-box; /* 确保内边距和边框不增加整体尺寸 */
  transition: width 0.3s ease; /* 添加宽度变化的过渡动画 */
  background: 
    linear-gradient(white, white) padding-box, /* 内容背景 */
    linear-gradient(to right,  #FFFE00, #FFFB02,#FFCC20) border-box; /* 边框背景 */

}
  @keyframes scroll {
    0% {
      transform: translateX(0);
    }
    25% {
      transform: translateX(-5%);
    }
    50%{
      transform: translateX(0);
    }
    75%{
      transform: translateX(5%);
    }
    100%{
      transform: translateX(0);
    }
  }
  @keyframes scrolltwo {
    0% {
      transform: translateX(0);
    }
    25% {
      transform: translateX(5%);
    }
    50%{
      transform: translateX(0);
    }
    75%{
      transform: translateX(-5%);
    }
    100%{
      transform: translateX(0);
    }
  }
 /* 鼠标悬停暂停动画 */
 .pc .parent:hover {
    animation-play-state: paused;
  }
   /* 鼠标悬停暂停动画 */
 .pc .parent-two:hover {
    animation-play-state: paused;
  }
 
  .phone .el-menu-item  > img {
  height: 36px;
  margin-top: 22px;
  margin-bottom: 22px;
  margin-left: 15px;
}
.phone .el-menu-demo{
  display: flex;
  justify-content: space-between;
}
.phone .phone-home{
  height: 800px;
  background-image: url('../assets/home_bg.png');
}
.phone .home-content-right > img{
  margin-top: 22px;
  width: 250px;
}
.phone .content_one{
  padding-top: 50px;
  background-image: url('../assets/content_one_bg.png');
  background-size: auto;
}
.phone .content_two{
  background-color: #FFF9E5 ;
  padding-top: 20px;
  overflow: hidden;
  padding-bottom: 50px;
}

.phone .content_two_title{
  font-size: 24px;
  font-weight: bold;
  padding-left: 20px;
  padding-right: 20px;
}
.phone .parent{
  text-align: center;
  display: flex;
  margin-top: 24px;
  justify-content: center;
  animation: scroll  20s linear infinite;
}
.phone .parent-two{
  display: flex;
  margin-top: 24px;
  justify-content: center;

  animation: scrolltwo  20s linear infinite;
}
.phone .show{
  border: 3px solid transparent;
  border-radius: 10px;
  min-width: 150px;
  font-size: 12px;
  min-height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px 12px 7px 12px;
  margin-left: 18px;
  padding: 5px;
  box-sizing: border-box; /* 确保内边距和边框不增加整体尺寸 */
  transition: width 0.3s ease; /* 添加宽度变化的过渡动画 */
  background: 
    linear-gradient(white, white) padding-box, /* 内容背景 */
    linear-gradient(to right,  #FFFE00, #FFFB02,#FFCC20) border-box; /* 边框背景 */

}
.phone .content_three{
  padding: 20px 20px 50px 20px;
}
.phone .content_three_title{
  font-size: 24px;
  font-weight: bold;
}
.phone .foot{
  background-color: #1A1A1A;
  height: 160px;
  text-align: left;
  padding-top: 30px;
  padding-left: 15px;
  padding-right: 15px;
}
</style>